import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: string;
  email: string;
  name?: string;
  avatarUrl?: string;
  isSuperAdmin?: boolean;
}

interface AuthState {
  token: string | null;
  user: User | null;
  hasSeenTutorial: boolean;
  setAuth: (token: string, user: User) => void;
  updateUser: (user: Partial<User>) => void;
  logout: () => void;
  markTutorialAsSeen: () => void;
}

// Importação lazy para evitar dependência circular
const resetWorkspaceStore = () => {
  // Acessa o store diretamente sem criar dependência circular com hook
  import('./workspace.store').then(({ useWorkspaceStore }) => {
    useWorkspaceStore.setState({ currentWorkspace: null, workspaces: [] });
  });
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      hasSeenTutorial: false,
      setAuth: (token, user) => set({ token, user }),
      updateUser: (data) => set((state) => ({ user: state.user ? { ...state.user, ...data } : state.user })),
      logout: () => {
        resetWorkspaceStore();
        set({ token: null, user: null, hasSeenTutorial: false });
      },
      markTutorialAsSeen: () => set({ hasSeenTutorial: true }),
    }),
    {
      name: 'auth-storage',
    }
  )
);
